import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTariffs } from 'app/entities/tariff/tariff.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tariff-pricing-constraint.reducer';

export const TariffPricingConstraintUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tariffs = useAppSelector(state => state.tariff.entities);
  const tariffPricingConstraintEntity = useAppSelector(state => state.tariffPricingConstraint.entity);
  const loading = useAppSelector(state => state.tariffPricingConstraint.loading);
  const updating = useAppSelector(state => state.tariffPricingConstraint.updating);
  const updateSuccess = useAppSelector(state => state.tariffPricingConstraint.updateSuccess);

  const handleClose = () => {
    navigate('/tariff-pricing-constraint');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTariffs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.minPrice !== undefined && typeof values.minPrice !== 'number') {
      values.minPrice = Number(values.minPrice);
    }
    if (values.maxPrice !== undefined && typeof values.maxPrice !== 'number') {
      values.maxPrice = Number(values.maxPrice);
    }

    const entity = {
      ...tariffPricingConstraintEntity,
      ...values,
      tariff: tariffs.find(it => it.id.toString() === values.tariff?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tariffPricingConstraintEntity,
          tariff: tariffPricingConstraintEntity?.tariff?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.tariffPricingConstraint.home.createOrEditLabel"
            data-cy="TariffPricingConstraintCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.home.createOrEditLabel">
              Create or edit a TariffPricingConstraint
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tariff-pricing-constraint-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.tariffPricingConstraint.minPrice')}
                id="tariff-pricing-constraint-minPrice"
                name="minPrice"
                data-cy="minPrice"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.tariffPricingConstraint.maxPrice')}
                id="tariff-pricing-constraint-maxPrice"
                name="maxPrice"
                data-cy="maxPrice"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.tariffPricingConstraint.effectiveDate')}
                id="tariff-pricing-constraint-effectiveDate"
                name="effectiveDate"
                data-cy="effectiveDate"
                type="date"
              />
              <ValidatedField
                id="tariff-pricing-constraint-tariff"
                name="tariff"
                data-cy="tariff"
                label={translate('crawlerBackendApp.tariffPricingConstraint.tariff')}
                type="select"
              >
                <option value="" key="0" />
                {tariffs
                  ? tariffs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/tariff-pricing-constraint"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TariffPricingConstraintUpdate;
